import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { MarqueeBanner } from './MarqueeBanner';
const GALLERY_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/sByBQM9SboUCpGRHk9ybHe/hf_20260422_165423_c76c7102-cf2a-4e04-9582-84a15db6d4ae.png',
  alt: 'Move Fighters team packing furniture with protective blankets'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/euGvuozjBpk8D5PQ4nko4t/hf_20260430_172859_d96aa42e-8f48-4abb-8f24-f4a230718ebe.png',
  alt: 'Move Fighters crew carefully packing items in a luxury home'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iTYYpcTGJzTWfgqJTS5LiS/c0caf911-3789-401c-97b8-b7c98f9285e5.jpg',
  alt: 'Move Fighters branded truck at customer home'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4aBxrQPt4QHCniW6QS7Fmh/hf_20260430_172717_e667c99f-785e-4196-a80e-61f75430d1ed.png',
  alt: 'Move Fighters team with happy family in front of new home'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bDsiYNuQ8erAmukFriRRF9/hf_20260422_174623_e30af3f1-1223-4108-8800-4eb20b3610cb.png',
  alt: 'Move Fighters team with happy family after successful move'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/729LLAyKpmyomFHJBCX5k9/hf_20260430_172336_7e65c4ed-a56e-4d64-bb04-df2b37f2af79.png',
  alt: 'Move Fighters movers with family and truck at new home'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3ggPGu3BXVnGiGeaZGP7ke/hf_20260422_174820_270eb1e1-1802-4bfc-93e6-eb810c1d4546.png',
  alt: 'Move Fighters movers shaking hands with satisfied customers'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qJxf1GBicQh7P4YQHvrRBx/hf_20260430_165935_f456fec4-6f67-4343-bc32-1ee8fbcb30b8.png',
  alt: 'Move Fighters full crew loading commercial office furniture'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/xq68dS7UboTH2GsTFTqsvi/hf_20260422_174400_edc25ebf-f2d5-4478-b937-d3e1d4bc7689.png',
  alt: 'Move Fighters team protecting and moving furniture in luxury home'
}];
export function GallerySection() {
  const {
    t
  } = useLanguage();
  const [activeIndex, setActiveIndex] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % GALLERY_IMAGES.length);
    }, 3000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);
  return <section className="py-14 bg-brand-dark relative overflow-hidden border-t border-white/5" data-id="element-427">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-428">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-429">
          <h2 className="font-oswald text-4xl md:text-5xl font-bold text-white mb-3 uppercase" data-id="element-430">
            {t.gallery.title}
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-431">
            {t.gallery.subtitle}
          </p>
        </motion.div>

        {/* Single large image — auto-slides only, no dots */}
        <div className="relative rounded-2xl overflow-hidden aspect-[16/9] md:aspect-[21/9] bg-brand-black" data-id="element-432">
          {GALLERY_IMAGES.map((img, index) => <motion.div key={index} initial={false} animate={{
          opacity: activeIndex === index ? 1 : 0,
          scale: activeIndex === index ? 1 : 1.08
        }} transition={{
          duration: 0.5,
          ease: 'easeInOut'
        }} className="absolute inset-0" data-id="element-433">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover" data-id="element-434" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-black/10" data-id="element-435" />
            </motion.div>)}

          {/* Top progress bar */}
          <div className="absolute top-0 left-0 right-0 z-10 flex gap-1 p-3" data-id="element-436">
            {GALLERY_IMAGES.map((_, index) => <div key={index} className="flex-1 h-1 rounded-full overflow-hidden bg-white/20" data-id="element-437">
                <motion.div key={`bar-${activeIndex}-${index}`} initial={{
              width: activeIndex === index ? '0%' : activeIndex > index ? '100%' : '0%'
            }} animate={{
              width: activeIndex === index ? '100%' : activeIndex > index ? '100%' : '0%'
            }} transition={{
              duration: activeIndex === index ? 3 : 0.3,
              ease: activeIndex === index ? 'linear' : 'easeOut'
            }} className="h-full bg-brand-red rounded-full" data-id="element-438" />
              </div>)}
          </div>
        </div>
      </div>

      <MarqueeBanner texts={['MOVE FIGHTERS', 'ORLANDO', 'RESCUE MOVERS']} direction="left" speed={20} bgFrom="from-brand-dark" className="mt-10" data-id="element-439" />
    </section>;
}